import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quileditor_New";
import Pattern from "./PatternTypes/Pattern";

function WorkExperienceItem(props) {
  const {
    headerHtml,
    styles,
    resumeHandler,
    resumeUpdate,
    response,
    index,
    handleDatePicker,
    handleEditorChange,
    changesetShowQuillToolbar,
    showQuillToolbar,
    sectionId,
  } = props;

  return (
    <>
      <Pattern
        headerHtml={headerHtml}
        response={response}
        index={index}
        resumeHandler={resumeHandler}
        resumeUpdate={resumeUpdate}
        styles={styles}
        sectionId={sectionId}
        handleDatePicker={handleDatePicker}
      />
      {response && response.showFields && response.showFields.description && (
        <div className="experience-description resume-description">
          <Quilleditor
            type="visual"
            showQuillToolbar={showQuillToolbar}
            changesetShowQuillToolbar={changesetShowQuillToolbar}
            theme="snow"
            className={``}
            inivalue={
              response?.description
                ? response?.description?.replace(/\n|\r/g, "")
                : ""
            }
            current={index}
            setvalue={handleEditorChange}
            onBlur={resumeUpdate}
            styles={styles}
            sectionId={sectionId}
            placeholder="Show your relevant experience (last 10 years). Use bullet points to note your achievements. if possible - use numbers/facts (Achieved X, measured by Y, by doing Z)"
          />
        </div>
      )}
    </>
  );
}

export default WorkExperienceItem;
